import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import BasicObject from 'model/basicObject'

export default class TicketMedicalNavigation extends BasicObject {
  constructor(init) {
    super(init)
    // console.log('> TicketMedicalNavigation constructor -', init)
    if (isNil(init)) return undefined
    this._employee_id = init.employee_id
    this._symptom_id = init.symptom_id
    this._symptom_name = init.symptom_name
    this._initial_care_choice_ids = init.initial_care_choice_ids
    this._recommended_care_choice_ids = init.recommended_care_choice_ids
  }

  static shape = {
    employee_id: PropTypes.string,
    symptom_id: PropTypes.string.isRequired,
    symptom_name: PropTypes.string.isRequired,
    initial_care_choice_ids: PropTypes.string,
    recommended_care_choice_ids: PropTypes.string
  }

  get employee_id() {
    return this._employee_id
  }

  get symptom_id() {
    return this._symptom_id
  }

  get symptom_name() {
    return this._symptom_name
  }

  get initial_care_choice_ids() {
    return this._initial_care_choice_ids
  }

  get recommended_care_choice_ids() {
    return this._recommended_care_choice_ids
  }
}
